module.exports = __webpack_public_path__ + "static/media/inactive-drip.b58dfa24.svg";